import { createContext, type ReactNode, useContext, useState } from "react";

interface ModalContextType {
	isModalOpen: boolean;
	setIsModalOpen: (isOpen: boolean) => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export function ModalProvider({ children }: { children: ReactNode }) {
	const [isModalOpen, setIsModalOpen] = useState(false);

	return (
		<ModalContext.Provider value={{ isModalOpen, setIsModalOpen }}>
			{children}
		</ModalContext.Provider>
	);
}

export function useModalState() {
	const context = useContext(ModalContext);
	if (context === undefined) {
		throw new Error("useModalState must be used within a ModalProvider");
	}
	return context;
}
